import { render, staticRenderFns } from "./media-asset-pick-dialog.vue?vue&type=template&id=9cb05a3c&scoped=true&"
import script from "./media-asset-pick-dialog.vue?vue&type=script&lang=js&"
export * from "./media-asset-pick-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cb05a3c",
  null
  
)

export default component.exports